import React, { useState } from "react";
import { X, Flag } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const REASONS = [
  { value: "harassment", label: "Harassment or trolling" },
  { value: "spam", label: "Spam or scam" },
  { value: "inappropriate", label: "Inappropriate content" },
  { value: "impersonation", label: "Impersonation" },
  { value: "other", label: "Something else" },
];

export default function ReportModal({ target, onClose }) {
  const [reason, setReason] = useState("harassment");
  const [details, setDetails] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/reports", {
        reported_id: target.id || null,
        reported_name: target.name || null,
        reason, details: details.trim() || null,
        context: target.context || null,
        show_id: target.show_id || null,
      });
      toast.success("Report submitted. Our team will review it.");
      onClose();
    } catch (e) { toast.error(e.message); } finally { setBusy(false); }
  };

  return (
    <div className="modal-backdrop" onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,.5)", display: "grid", placeItems: "center", zIndex: 80 }}>
      <div className="ss-card" onClick={(e) => e.stopPropagation()} data-testid="report-modal" style={{ width: 440, maxWidth: "92vw", padding: 22 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
          <div style={{ fontWeight: 800, fontSize: 18, display: "flex", alignItems: "center", gap: 8 }}><Flag size={18} style={{ color: "var(--red)" }} /> Report {target.name || "user"}</div>
          <button className="ss-btn ss-btn-ghost ss-btn-sm" onClick={onClose} data-testid="report-close"><X size={16} /></button>
        </div>
        <p className="ss-muted" style={{ fontSize: 13, marginBottom: 16 }}>Tell us what's wrong. Reports are private and reviewed by our team.</p>

        <label className="ss-label">Reason</label>
        <select className="ss-field" style={{ width: "100%" }} value={reason} onChange={(e) => setReason(e.target.value)} data-testid="report-reason">
          {REASONS.map((r) => <option key={r.value} value={r.value}>{r.label}</option>)}
        </select>

        <label className="ss-label" style={{ marginTop: 14 }}>Details (optional)</label>
        <textarea value={details} onChange={(e) => setDetails(e.target.value)} maxLength={1000} placeholder="Add anything that helps us understand…" data-testid="report-details"
          style={{ width: "100%", minHeight: 90, resize: "vertical", padding: "10px 12px", borderRadius: 12, border: "1px solid var(--line)", background: "var(--surface-2)", color: "var(--text)", fontSize: 14, fontFamily: "inherit" }} />

        <div style={{ display: "flex", gap: 10, marginTop: 18 }}>
          <button className="ss-btn ss-btn-ghost" style={{ flex: 1 }} onClick={onClose}>Cancel</button>
          <button className="ss-btn ss-btn-primary" style={{ flex: 1, background: "var(--red)", borderColor: "var(--red)" }} disabled={busy} onClick={submit} data-testid="report-submit">{busy ? "Submitting…" : "Submit report"}</button>
        </div>
      </div>
    </div>
  );
}
